import { ReactNode, useContext } from 'react';

import { Button } from '../../../../cdl/Button/Button';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';

import { CreateWebhookContext } from './CreateWebhookContext';

interface WebhookFormButtonAreaProps {
    children: ReactNode;
}

export const WebhookFormButtonArea = ({ children }: WebhookFormButtonAreaProps) => {
    const { onDismiss } = useContext(CreateWebhookContext);

    return (
        <Box display="flex" justifyContent="space-between">
            <Button type="button" emphasis="low" onClick={onDismiss}>
                {translate('btn.cancel')}
            </Button>

            {children}
        </Box>
    );
};
